// src/components/pages/AdvertiserDisclosure.jsx
import { Box, Container, Heading, Text, Stack } from "@chakra-ui/react";

export default function AdvertiserDisclosure() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          Advertiser Disclosure
        </Heading>
        <Stack spacing={4} fontSize="md">
          <Text>
            We may receive compensation when you click links or call numbers on
            this site. This may influence placement but not our editorial
            opinions.
          </Text>
          <Text>
            We strive for fairness, accuracy, and transparency in all
            evaluations.
          </Text>
          <Text fontSize="sm" opacity={0.8}>
            Last updated: {new Date().toLocaleDateString()}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
